module.exports = __webpack_public_path__ + "static/media/equipment03.ae197f0e.jpg";